<template>
    <div class="relative">
        <div class="absolute top-0 left-0 w-full h-full">
            <nuxt-img :src="backgroundImageSrc" sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw" preload
                fetchpriority="high" loading="eager" width="1920" height="1018" :alt="backgroundImageAlt" format="webp"
                class="object-cover w-full h-full" />
        </div>
        <div class="relative z-10 px-6 pt-6 mx-auto max-w-screen-2xl">
            <div class="flex z-20 gap-2 justify-between items-center sm:gap-4 lg:gap-x-8">
                <div class="relative">
                    <a href="/">
                        <nuxt-img :src="logoSrc" :alt="logoAlt" width="167" height="64"
                            class="object-contain relative z-10 w-28 md:w-40" />
                    </a>
                </div>



                <div class="flex">
                    <!-- Phone number - hidden on mobile -->
                    <a :href="`tel:${phoneNumber}`"
                        class="flex gap-2 items-center px-4 py-2 text-base text-white rounded-full transition xl:px-4 lg:px-0 lg:text-black sm:py-2.5 font-ww-medium 3xl:text-white">
                        <svg class="text-white lg:text-black 3xl:text-white us-max:hidden" width="25" height="26"
                            viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.5586 4.67578C16.8831 5.03125 18.0908 5.72885 19.0606 6.69857C20.0303 7.66829 20.7279 8.87602 21.0833 10.2005"
                                stroke="currentColor" stroke-width="1.56177" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.748 7.69141C15.5447 7.90297 16.2712 8.32137 16.854 8.90419C17.4368 9.48701 17.8552 10.2135 18.0668 11.0102"
                                stroke="currentColor" stroke-width="1.56177" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M9.0308 12.9532C9.83435 14.6126 11.1762 15.951 12.8376 16.7503C12.9602 16.8083 13.0957 16.8334 13.2309 16.8232C13.3661 16.8129 13.4963 16.7676 13.6087 16.6917L16.049 15.0616C16.1568 14.9885 16.2814 14.9439 16.4111 14.9319C16.5408 14.92 16.6715 14.9411 16.7908 14.9933L21.359 16.9553C21.5151 17.0202 21.6456 17.1347 21.7302 17.2811C21.8149 17.4275 21.8491 17.5977 21.8275 17.7654C21.6827 18.8955 21.1311 19.9341 20.276 20.6869C19.4208 21.4397 18.3206 21.855 17.1813 21.8553C13.6605 21.8553 10.284 20.4567 7.79441 17.9671C5.30486 15.4776 3.90625 12.101 3.90625 8.58028C3.90651 7.44097 4.32189 6.34078 5.07467 5.48559C5.82746 4.6304 6.86605 4.07881 7.99613 3.93402C8.16386 3.91247 8.33403 3.94666 8.48042 4.03132C8.62681 4.11599 8.74131 4.24642 8.8063 4.40255L10.7683 8.98048C10.8193 9.09795 10.8406 9.22617 10.8304 9.35384C10.8202 9.4815 10.7787 9.60469 10.7097 9.71256L9.07961 12.1919C9.00703 12.304 8.96444 12.4329 8.95589 12.5662C8.94735 12.6995 8.97314 12.8327 9.0308 12.9532Z"
                                stroke="currentColor" stroke-width="1.56177" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span class="contents"><span class="hidden sm:block">{{ phoneLabel }}</span>
                            {{ phoneNumber }}</span></a>
                </div>
            </div>
        </div>

        <div class="flex relative z-10 flex-col pt-10 mx-auto lg:pt-20 lg:pb-20 lg:flex-row md-max:pt-6">
            <div class="lg:ml-[calc((100vw_-_1024px)_/_2)] mx-auto xl:px-0 px-4">
                <div class="max-w-3xl lg:max-w-2xl xl:max-w-3xl">
                    <div class="text-center  text-[#C4E538] xl:text-2xl text-lg sm:text-xl font-ww-medium lg:text-left">
                        {{ attentionText }}
                    </div>

                    <h1 class="mt-2 !leading-none text-center text-white text-3xl sm:text-4xl lg:text-left xl:text-53 font-ww-medium"
                        v-html="mainHeadline">
                    </h1>

                    <div class="my-6 h-0.5 lg:mr-24" style="background:#5F5F5F">
                    </div>

                    <div>
                        <svg width="121" height="18" viewBox="0 0 121 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect width="121" height="18" fill="#1E1E1E" />
                            <g id="Neurobics Optin Page Rev3" clip-path="url(#clip0_0_1)">
                                <rect width="1440" height="22038" transform="translate(-224 -472)" fill="white" />
                                <rect id="image 30" x="-225.389" y="-472.234" width="1441.73" height="768.113"
                                    fill="#1C1C1C" />
                                <g id="Group 39617">
                                    <g id="Group 39618">
                                        <g id="Group 233">
                                            <path id="Vector"
                                                d="M7.33209 5.69796C7.33209 5.69796 3.81805 6.08717 1.47388 6.34739C1.26259 6.37296 1.07577 6.51419 1.00571 6.72882C0.935649 6.94344 1.00571 7.16696 1.16139 7.30819C2.90284 8.89729 5.51947 11.2771 5.51947 11.2771C5.51724 11.2771 4.80109 14.7388 4.32514 17.0485C4.28511 17.2576 4.36073 17.4789 4.5431 17.6112C4.72436 17.7435 4.95789 17.7458 5.14138 17.6424C7.19197 16.4769 10.2634 14.7244 10.2634 14.7244C10.2634 14.7244 13.336 16.4769 15.3832 17.6435C15.5701 17.7458 15.8036 17.7435 15.9849 17.6112C16.1672 17.4789 16.2428 17.2576 16.2017 17.0496C15.7257 14.7388 15.0107 11.2771 15.0107 11.2771C15.0107 11.2771 17.6273 8.89729 19.3688 7.31152C19.5245 7.16585 19.5934 6.94233 19.5245 6.72882C19.4555 6.51531 19.2687 6.37408 19.0574 6.34961C16.7132 6.08717 13.1981 5.69796 13.1981 5.69796C13.1981 5.69796 11.7413 2.47527 10.7705 0.326817C10.6793 0.134435 10.4881 -0.00012207 10.2634 -0.00012207C10.0388 -0.00012207 9.84641 0.135547 9.75967 0.326817C8.78775 2.47527 7.33209 5.69796 7.33209 5.69796Z"
                                                fill="#F1594B" />
                                            <path id="Vector_2"
                                                d="M32.6878 5.69796C32.6878 5.69796 29.1738 6.08717 26.8296 6.34739C26.6183 6.37296 26.4315 6.51419 26.3614 6.72882C26.2914 6.94344 26.3614 7.16696 26.5171 7.30819C28.2586 8.89729 30.8752 11.2771 30.8752 11.2771C30.873 11.2771 30.1568 14.7388 29.6809 17.0485C29.6408 17.2576 29.7164 17.4789 29.8988 17.6112C30.0801 17.7435 30.3136 17.7458 30.4971 17.6424C32.5477 16.4769 35.6191 14.7244 35.6191 14.7244C35.6191 14.7244 38.6917 16.4769 40.739 17.6435C40.9258 17.7458 41.1593 17.7435 41.3406 17.6112C41.5229 17.4789 41.5986 17.2576 41.5574 17.0496C41.0815 14.7388 40.3664 11.2771 40.3664 11.2771C40.3664 11.2771 42.983 8.89729 44.7245 7.31152C44.8802 7.16585 44.9491 6.94233 44.8802 6.72882C44.8112 6.51531 44.6244 6.37408 44.4131 6.34961C42.069 6.08717 38.5538 5.69796 38.5538 5.69796C38.5538 5.69796 37.097 2.47527 36.1262 0.326817C36.035 0.134435 35.8438 -0.00012207 35.6191 -0.00012207C35.3945 -0.00012207 35.2021 0.135547 35.1154 0.326817C34.1435 2.47527 32.6878 5.69796 32.6878 5.69796Z"
                                                fill="#F1594B" />
                                            <path id="Vector_3"
                                                d="M58.0469 5.69808C58.0469 5.69808 54.5329 6.08729 52.1887 6.34751C51.9774 6.37309 51.7906 6.51432 51.7206 6.72894C51.6505 6.94356 51.7206 7.16708 51.8762 7.30831C53.6177 8.89741 56.2343 11.2772 56.2343 11.2772C56.2321 11.2772 55.5159 14.7389 55.04 17.0486C55 17.2577 55.0756 17.479 55.2579 17.6113C55.4392 17.7437 55.6727 17.7459 55.8562 17.6425C57.9068 16.4771 60.9783 14.7245 60.9783 14.7245C60.9783 14.7245 64.0508 16.4771 66.0981 17.6436C66.2849 17.7459 66.5184 17.7437 66.6997 17.6113C66.8821 17.479 66.9577 17.2577 66.9165 17.0498C66.4406 14.7389 65.7256 11.2772 65.7256 11.2772C65.7256 11.2772 68.3422 8.89741 70.0836 7.31165C70.2393 7.16597 70.3083 6.94245 70.2393 6.72894C70.1704 6.51543 69.9835 6.3742 69.7723 6.34973C67.4281 6.08729 63.9129 5.69808 63.9129 5.69808C63.9129 5.69808 62.4562 2.4754 61.4854 0.326939C61.3942 0.134557 61.2029 0 60.9783 0C60.7536 0 60.5612 0.135669 60.4745 0.326939C59.5026 2.4754 58.0469 5.69808 58.0469 5.69808Z"
                                                fill="#F1594B" />
                                            <path id="Vector_4"
                                                d="M83.4022 5.69796C83.4022 5.69796 79.8882 6.08717 77.544 6.34739C77.3327 6.37296 77.1459 6.51419 77.0758 6.72882C77.0058 6.94344 77.0758 7.16696 77.2315 7.30819C78.973 8.89729 81.5896 11.2771 81.5896 11.2771C81.5874 11.2771 80.8712 14.7388 80.3953 17.0485C80.3552 17.2576 80.4309 17.4789 80.6132 17.6112C80.7945 17.7435 81.028 17.7458 81.2115 17.6424C83.2621 16.4769 86.3336 14.7244 86.3336 14.7244C86.3336 14.7244 89.4061 16.4769 91.4534 17.6435C91.6402 17.7458 91.8737 17.7435 92.055 17.6112C92.2374 17.4789 92.313 17.2576 92.2718 17.0496C91.7959 14.7388 91.0808 11.2771 91.0808 11.2771C91.0808 11.2771 93.6975 8.89729 95.4389 7.31152C95.5946 7.16585 95.6635 6.94233 95.5946 6.72882C95.5257 6.51531 95.3388 6.37408 95.1275 6.34961C92.7834 6.08717 89.2682 5.69796 89.2682 5.69796C89.2682 5.69796 87.8114 2.47527 86.8406 0.326817C86.7495 0.134435 86.5582 -0.00012207 86.3336 -0.00012207C86.1089 -0.00012207 85.9165 0.135547 85.8298 0.326817C84.8579 2.47527 83.4022 5.69796 83.4022 5.69796Z"
                                                fill="#F1594B" />
                                            <path id="Vector_5"
                                                d="M108.76 5.69808C108.76 5.69808 105.246 6.08729 102.902 6.34751C102.69 6.37309 102.504 6.51432 102.433 6.72894C102.363 6.94356 102.433 7.16708 102.589 7.30831C104.331 8.89741 106.947 11.2772 106.947 11.2772C106.945 11.2772 106.229 14.7389 105.753 17.0486C105.713 17.2577 105.788 17.479 105.971 17.6113C106.152 17.7437 106.386 17.7459 106.569 17.6425C108.62 16.4771 111.691 14.7245 111.691 14.7245C111.691 14.7245 114.764 16.4771 116.811 17.6436C116.998 17.7459 117.231 17.7437 117.413 17.6113C117.595 17.479 117.671 17.2577 117.629 17.0498C117.153 14.7389 116.438 11.2772 116.438 11.2772C116.438 11.2772 119.055 8.89741 120.797 7.31165C120.952 7.16597 121.021 6.94245 120.952 6.72894C120.883 6.51543 120.696 6.3742 120.485 6.34973C118.141 6.08729 114.626 5.69808 114.626 5.69808C114.626 5.69808 113.169 2.4754 112.198 0.326939C112.107 0.134557 111.916 0 111.691 0C111.467 0 111.274 0.135669 111.187 0.326939C110.215 2.4754 108.76 5.69808 108.76 5.69808Z"
                                                fill="#F1594B" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_0_1">
                                    <rect width="1440" height="22038" fill="white" transform="translate(-224 -472)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>

                    <div class="my-5 text-lg font-bold text-white sm:text-xl xl:text-22 font-ww-medium"
                        v-html="testimonialQuote">
                    </div>

                    <div class="pr-20 max-w-2xl text-sm text-white sm:text-base xl:text-lg font-ww-light !leading-5"
                        v-html="testimonialText">
                    </div>

                    <div class="mt-5 text-base text-white font-ww-bold sm:text-lg xl:text-xl"
                        v-html="testimonialAuthor">
                    </div>
                </div>
            </div>

            <nuxt-img :src="heroImageSrc" sizes="xs:305px sm:425px md:366px lg:504px xl:494px" preload
                fetchpriority="high" loading="eager" width="412" height="491" :alt="heroImageAlt" format="webp"
                class="lg:absolute right-0 xl:w-[572px] lg:w-5/12 sm:w-6/12 mx-auto bottom-0" />
        </div>
    </div>
</template>

<script setup>
defineProps({
    backgroundImageSrc: {
        type: String,
        default: '/assets/images/bg-neurobics.jpg'
    },
    backgroundImageAlt: {
        type: String,
        default: 'hero background'
    },
    logoSrc: {
        type: String,
        default: '/assets/images/horizontal-logo.png'
    },
    logoAlt: {
        type: String,
        default: 'logo'
    },
    phoneNumber: {
        type: String,
        default: '1-800-479-1596'
    },
    phoneLabel: {
        type: String,
        default: 'Call Us Toll Free'
    },
    attentionText: {
        type: String,
        default: 'ATTENTION COFFEE DRINKERS'
    },
    mainHeadline: {
        type: String,
        default: 'How To Get All-Day Focused Energy Without Jitters, Crashes, And The Dreaded Afternoon Slump'
    },
    testimonialQuote: {
        type: String,
        default: '"My Brain Fog Is Gone – I\'m Hooked!"'
    },
    testimonialText: {
        type: String,
        default: 'I\'ve tried a ton of things, but Mindflow is different. Within 15–20 minutes of drinking it, I feel sharp, clear-headed, and ready to take on my day. No jitters, no crash — just clean, sustained mental energy.'
    },
    testimonialAuthor: {
        type: String,
        default: '– Jessica M.'
    },
    heroImageSrc: {
        type: String,
        default: '/assets/images/side-view-woman-meditating-nature 1-new.png'
    },
    heroImageAlt: {
        type: String,
        default: 'hero background'
    }
})

defineBuilderComponent({
    friendlyName: 'Product Intro Hero',
    canHaveChildren: false,
    inputs: [
        {
            name: 'backgroundImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/bg-neurobics.jpg'
        },
        {
            name: 'backgroundImageAlt',
            type: 'text',
            defaultValue: 'hero background'
        },
        {
            name: 'logoSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            defaultValue: '/assets/images/horizontal-logo.png'
        },
        {
            name: 'logoAlt',
            type: 'text',
            defaultValue: 'logo'
        },
        {
            name: 'phoneNumber',
            type: 'text',
            defaultValue: '1-800-479-1596'
        },
        {
            name: 'phoneLabel',
            type: 'text',
            defaultValue: 'Call Us Toll Free'
        },
        {
            name: 'attentionText',
            type: 'richText',
            defaultValue: 'ATTENTION COFFEE DRINKERS'
        },
        {
            name: 'mainHeadline',
            type: 'richText',
            defaultValue: 'How To Get All-Day Focused Energy Without Jitters, Crashes, And The Dreaded Afternoon Slump'
        },
        {
            name: 'testimonialQuote',
            type: 'richText',
            defaultValue: '"My Brain Fog Is Gone – I\'m Hooked!"'
        },
        {
            name: 'testimonialText',
            type: 'richText',
            defaultValue: 'I\'ve tried a ton of things, but Mindflow is different. Within 15–20 minutes of drinking it, I feel sharp, clear-headed, and ready to take on my day. No jitters, no crash — just clean, sustained mental energy.'
        },
        {
            name: 'testimonialAuthor',
            type: 'richText',
            defaultValue: '– Jessica M.'
        },
        {
            name: 'heroImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/side-view-woman-meditating-nature 1-new.png'
        },
        {
            name: 'heroImageAlt',
            type: 'text',
            defaultValue: 'hero background'
        }
    ]
})
</script>